import { render } from "./CrossWord.vue?vue&type=template&id=29e1310e&scoped=true"
import script from "./CrossWord.vue?vue&type=script&lang=js"
export * from "./CrossWord.vue?vue&type=script&lang=js"

import "./CrossWord.vue?vue&type=style&index=0&id=29e1310e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e1310e"]])

export default __exports__